// Options hooks
export const DIFF = '__b';
export const RENDER = '__r';
export const DIFFED = 'diffed';
export const COMMIT = '__c';
export const SKIP_EFFECTS = '__s';
export const CATCH_ERROR = '__e';

// VNode properties
export const COMPONENT = '__c';
export const CHILDREN = '__k';
export const PARENT = '__';
export const MASK = '__m';

// Component properties
export const VNODE = '__v';
export const DIRTY = '__d';
export const BITS = '__g';
export const NEXT_STATE = '__s';
export const CHILD_DID_SUSPEND = '__c';
